
let carouselInterval;

export async function doPageHeader(root = null) {

  const header = document.querySelector('.rbt-page-header');
  if (!header) return false;
  try {
    // Load the header image first, blocking other tasks
    await loadPageHeaderImg(header);
  } catch (error) {
    console.error('Error loading images:', error);
  }
  /* to chain the doPageHeader on the home page */
  if (root) return root;
}

export function doVideo(root = null) {

  if (!root) return false;
  try {
    loadPageHeaderImgVideo(root);
  } catch (error) {
    console.error('Error loading video:', error);
  }
}

export async function doCarousel(carousel) {
  const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
  if (vw > 1080) {
    try {
      await loadPageHeaderImg(carousel);
      await loadAllSlideImages(carousel);



      const inner = carousel.querySelector('.slider-inner');
      const slider = carousel.querySelector('.rbt-carousel');

      if (slider && inner) {
        const loadImageEl = carousel.querySelector('.load-image');
        if (loadImageEl) loadImageEl.remove();

        inner.classList.remove('critical-hidden');
        startCarousel(slider);
      }
    } catch (error) {
      console.error('Error setting up carousel:', error);
      return;
    }
  }
  if (vw <= 1080) {
    try {
      await loadPageHeaderImg(carousel);
    } catch (error) {
      console.error('Error setting up carousel:', error);
      return;
    }
  }
}
/* Returns: Promise -> src for image URL */
const loadImage = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = src;
    img.onload = () => resolve(src);
    img.onerror = reject;
  });
};

/* @Todo - I want to move the carousel to a promise after onReady is fired */
const loadAllSlideImages = async (rootEl) => {
  const slides = [...rootEl.querySelectorAll('.slide')];
  const userAgent = navigator.userAgent.toLowerCase();
  const isBot = /bot|crawl|slurp|spider|googlebot|bingbot|yahoo|duckduckbot|robot/i.test(userAgent);
  const isMobile = /iphone|ipod|ipad|android/i.test(userAgent);


  const imagePromises = slides.map((slide) => {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const imgKey = dataImageKey(vw, isBot, isMobile);
    const imgSrc = imgKey === 'full'
      ? slide.getAttribute('data-img')
      : slide.getAttribute(`data-img-${imgKey}`);

    return loadImage(imgSrc).then((src) => {
      const img = slide.querySelector('img'); // Find image in the slide
      if (img) {
        img.setAttribute('src', src); // Only set src if the image exists
      } else {
        console.warn('No image found in slide:', slide); // Log a warning if img is missing
      }
    }).catch((error) => {
      console.error('Error loading image for slide:', slide, error); // Handle load error
    });
  });

  // Wait for all slide images to load
  await Promise.all(imagePromises);
  return rootEl;
};


const unblurAndUpdate = (img, src) => {
  // Unblurs the image after loading
  img.setAttribute('src', src);
  img.style.transition = 'filter 500ms ease-out';
  img.style.filter = 'blur(0)';
};



// const loadPageHeaderImgVideo = (carousel) => {
//   const isMobile = window.innerWidth <= 1080; // Adjust the breakpoint as needed
//   const videoWrap = carousel.querySelector('.video-wrap');
//   if (!videoWrap) {
//     console.warn('No video wrap found in video header:', carousel);
//     return;
//   }
//   const videoSource = isMobile ? videoWrap.dataset.homeVideoMobile : videoWrap.dataset.homeVideo;
//   const poster = isMobile ? videoWrap.dataset.mobileVideoPoster : videoWrap.dataset.homeVideoPoster;

//   const loader = videoWrap.querySelector('.home-video-loading-loader');

//   // Check for video source or poster

//   //For Mobile speed scores the most typical setup is mobile poster with no video - 
//   const promises = [
//     videoSource
//       ? fetch(videoSource, { method: "HEAD" }).then(() => videoSource).catch(() => null)
//       : Promise.resolve(null),
//     poster
//       ? fetch(poster, { method: "HEAD" }).then(() => poster).catch(() => null)
//       : Promise.resolve(null)
//   ];


//   Promise.all(promises).then(([validVideoSource, validPoster]) => {
//     if (validVideoSource || validPoster) {
//       let newMarkup = '';
//       if (!isMobile && validVideoSource) {
//         newMarkup += `<video autoplay muted loop playsinline${validPoster ? ` poster="${validPoster}"` : ""}>`;
//         newMarkup += `<source src="${validVideoSource}" type="video/mp4">`;
//         newMarkup += `</video>`;
//       } else if (validPoster) {
//         newMarkup += `<div style='background-image: url("${validPoster}"); height: 100%; width: 100%;'></div>`;
//       } else {
//         loader.remove(); // No valid sources or poster
//       }
//       loader.innerHTML = newMarkup;
//     } else {
//       loader.remove(); // No valid sources or poster
//     }
//   });
// }

const loadPageHeaderImgVideo = (carousel) => {

  const isMobile = window.innerWidth <= 1080;
  const videoWrap = carousel.querySelector('.video-wrap');
  if (!videoWrap) {
    console.warn('No video wrap found in video header:', carousel);
    return;
  }

  const videoSource = isMobile ? videoWrap.dataset.homeVideoMobile : videoWrap.dataset.homeVideo;
  const poster = isMobile ? videoWrap.dataset.mobileVideoPoster : videoWrap.dataset.homeVideoPoster;
  const loader = videoWrap.querySelector('.home-video-loading-loader');

  // Step 1: Load poster first
  const loadPoster = poster
    ? fetch(poster, { method: 'HEAD' })
      .then(() => {

        //loader.innerHTML = `<div style='background-image: url("${poster}"); height: 100%; min-height:450px; width: 100%;'></div>`;
        loader.style.backgroundImage = `url("${poster}")`;
        loader.style.height = '100%';
        loader.style.minHeight = '450px';
        loader.style.width = '100%';
        loader.style.backgroundSize = 'cover';
        loader.style.backgroundPosition = 'center';
        return poster;
      })
      .catch(() => null)
    : Promise.resolve(null);

  // Step 2: Once poster is handled, check video
  loadPoster.then((validPoster) => {
    if (!videoSource || isMobile) return; // Skip if no video or mobile mode

    fetch(videoSource, { method: 'HEAD' })
      .then(() => {
        loader.innerHTML = `
          <video autoplay muted loop playsinline${validPoster ? ` poster="${validPoster}"` : ''}>
            <source src="${videoSource}" type="video/mp4">
          </video>
        `;
      })
      .catch(() => {
        // Keep poster if video doesn't exist
      });
  });
};

async function loadPageHeaderImg(carousel) {
  if (carousel.classList.contains('video')) {
    loadPageHeaderImgVideo(carousel);
    return true;
  }
  const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
  const targetImg = carousel.querySelector('.load-image');
  const userAgent = navigator.userAgent.toLowerCase();

  // Check if it's a bot (common user-agent strings)
  const isBot = /bot|crawl|slurp|spider|googlebot|bingbot|yahoo|duckduckbot|robot/i.test(userAgent);
  const isMobile = /iphone|ipod|ipad|android/i.test(userAgent);

  const imgKey = dataImageKey(vw, isBot, isMobile);
  let imgSrc = imgKey === 'full'
    ? carousel.getAttribute('data-img')
    : carousel.getAttribute(`data-img-${imgKey}`);

  if (!imgSrc) imgSrc = carousel.getAttribute('data-img'); //fallback to full

  try {
    const loadedImg = await loadImage(imgSrc); // Wait for the image to load
    unblurAndUpdate(targetImg, loadedImg); // Unblur and set the loaded image
    return carousel;
  } catch (error) {
    console.error('Image loading failed:', error);
    return carousel; // Return root element even if loading fails
  }

}

const dataImageKey = (vw, isBot, isMobile) => {
  if (vw < 640 || isBot) return 'sm';
  else if (vw < 1080 || isMobile) return 'md';
  else if (vw >= 1080) return 'lg'; // only return lg to crop correctly
  // else if (vw <= 1440) return 'lg';
  // else if (vw > 1440) return 'full'
  return 'sm'; //safety
};

export function startCarousel(carousel, index = 0, interval = 6000) {
  const slides = carousel.querySelectorAll(".slide");
  const header = carousel.closest(".carousel-header");
  const nav = carousel.querySelectorAll(".home-main-nav-headline");

  let currentSlide = index;

  // Clear any existing interval
  if (carouselInterval) {
    clearInterval(carouselInterval);
  }

  // Set a new interval
  carouselInterval = setInterval(() => {
    // Remove 'active' class from current slide
    slides[currentSlide].classList.remove("active");
    nav[currentSlide].classList.remove("active");

    // Calculate next slide index
    currentSlide = (currentSlide + 1) % slides.length;

    // Add 'active' class to next slide
    slides[currentSlide].classList.add("active");
    nav[currentSlide].classList.add("active");

    // Ensure other slides are inactive
    slides.forEach((slide, i) => {
      if (i !== currentSlide) {
        slide.classList.remove("active");
        nav[i].classList.remove("active");
      }
    });
  }, interval);
}

export function carouselIndicatorClick(event) {
  const indicator = event.target;
  const slideTo = parseInt(indicator.getAttribute("data-slide-to"));
  const carousel = indicator.closest(".rbt-carousel");
  startCarousel(carousel, slideTo);
}

/* EXAMPLE MARKUP
<section class="rbt-page-header page"
  data-img="http://localhost:8013/wp-content/uploads/2024/06/host-exchange-student.png"
  data-img-lg="http://localhost:8013/wp-content/uploads/2024/06/host-exchange-student-1440x568.png"
  data-img-md="http://localhost:8013/wp-content/uploads/2024/06/host-exchange-student-1080x426.png"
  data-img-sm="http://localhost:8013/wp-content/uploads/2024/06/host-exchange-student-640x252.png"
>
<img class="load-image" src="http://localhost:8013/wp-content/uploads/2024/06/host-exchange-student-80x32.png" alt="Host an Exchange Student" loading="eager">

\add_image_size('desktop-page-header', 1440);
\add_image_size('desktop-page-header-md', 1080);
\add_image_size('mobile-page-header', 640);

\add_image_size( 'rbt-tiny', 80);
\add_image_size( 'rbt-square-lg', 900, 900, ['top', 'center']);
\add_image_size( 'rbt-square-md', 500, 500, ['top', 'center']);
\add_image_size( 'rbt-landscape-md', 900, 506, ['center', 'center']);
\add_image_size( 'rbt-landscape-mobile', 500, 281, ['center', 'center']);

*/